import styled from "styled-components";

const cellHeight = 24;

export const Container = styled.div<{
  numberOfLines: number;
}>`
  position: relative;
  width: 100%;
  height: ${({ numberOfLines }) => cellHeight * numberOfLines}px;
`;

export const Node = styled.div<{
  level: number;
  highlighted: boolean;
  truncated: boolean;
}>`
  box-sizing: border-box;
  position: absolute;

  height: ${cellHeight}px;
  top: ${({ level }) => cellHeight * level}px;

  opacity: ${({ truncated }) => (truncated ? 0.4 : 1)};

  background-color: var(--theme-neutral-100);
  border: 1px solid
    ${({ highlighted }) =>
      highlighted
        ? "var(--mode-border-primary-strong)"
        : "var(--section-snow-background-color, var(--snow))"} !important;
  border-left-width: ${({ truncated }) => (truncated ? 0 : 1)}px !important;
  border-right-width: ${({ truncated }) => (truncated ? 0 : 1)}px !important;
  box-shadow: none !important;

  cursor: pointer;

  &:hover > div {
    border-color: var(--theme-neutral-400);
  }

  > div {
    position: absolute;
  }
`;

export const NodeBackground = styled.div`
  background-color: var(--profile-type-color);
  left: 1px;
  right: 1px;
  top: 1px;
  bottom: 1px;
`;

export const NodeLabel = styled.div`
  left: 4px;
  right: 4px;
  top: 2px;
  bottom: 2px;
  overflow: hidden;
  display: block;
  font-size: 12px;
  min-width: 1px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
